import {OrganisationDeploymentState} from '@cquential/api';

export class OrganisationUtil {
    public static getDefaultState(deploymentStates: Record<number, OrganisationDeploymentState>): number {
        let state: number | undefined;
        for (const deploymentStateId in deploymentStates) {
            if (deploymentStates[deploymentStateId]) {
                state = deploymentStates[deploymentStateId].deploymentStateId;
                break;
            }
        }

        if (!state) {
            throw Error('No usable default state');
        }

        return state;
    }
}
